import {createAsyncThunk} from '@reduxjs/toolkit';
import ProviderManager from '../../../../provider/providerManager';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {resetFamilyPackageUsageDetails} from 'app/Components/Block/CellcomAbroadLobbyBlock/cellcomAbroadBlockSlice';

function shouldResetFamilyPackageUsage(state, soc, endDate) {
  return state.selfcarePage
    ?.selectedSubscriber?.abroadPackages?.regularPackages
    ?.some(({ isFamilyBundle, socExpDate, socName }) =>
      isFamilyBundle && soc?.trim() === socName?.trim() && endDate === socExpDate
    ) ?? false;
}

export const abroadRemoveAndAddSoc = createAsyncThunk('cellcomAbroad/abroadRemoveAndAddSoc', async (data, thunkAPI) => {
  try {
    const familyBundleData = thunkAPI.getState().cellcomAbroad.familyBundleData || {};
    const fm = familyBundleData.flightManager;
    const flightManagerPhoneFromState = fm?.phone || fm?.productSubscriberNo || null;
    const fmPhoneForFilter = data.subscriberNumber || flightManagerPhoneFromState;
    const flightManagerPhone = data.isFamilyBundleEdit ? null : flightManagerPhoneFromState;

    const excludeFlightManager = (phones) =>
      fmPhoneForFilter ? phones.filter((p) => p && p !== fmPhoneForFilter) : phones;

    let selectedMembersPhones = (familyBundleData.selectedMembers || []).map((m) => m?.phone);
    let removedMembersPhones = (familyBundleData.removedMembers || []).map((m) => m?.phone);

    if (data.isFamilyBundleEdit) {
      selectedMembersPhones = excludeFlightManager(selectedMembersPhones);
      removedMembersPhones = excludeFlightManager(removedMembersPhones);
    }

    var state = thunkAPI.getState().cellcomAbroad;
    var selectedAbroadPackage = state.selectedAbroadPackage;
    var newPackage = {...selectedAbroadPackage, startDate: data.startDate};
    var couponCode= state.coupon?.voucherCategory || '';
    var couponSerial =  state.coupon?.code || '';


    const result = await ProviderManager.getProviderData('abroadRemoveAndAddSoc', [
      data.subscriberNumber,
      data.soc,
      data.startDate,
      data.endDate,
      data.countries,
      data.blockId,
      data.shouldRemoveSurfingBlockage,
      data.type,
      data.signCollaborationApproval,
      data.isShelfEpi,
      flightManagerPhone,
      selectedMembersPhones,
      removedMembersPhones, // members removed in edit flow – read from slice, backend uses this to remove their SOC
      couponCode,
      couponSerial,
    ]);

    if (result?.Body?.isSuccess && shouldResetFamilyPackageUsage(thunkAPI.getState(), data?.soc, data?.endDate)) {
      thunkAPI.dispatch(resetFamilyPackageUsageDetails());
    }
    var mobile = data.subscriberNumber; // Store mobile number before async calls

    return {...result, mobile: mobile, newPackage: newPackage, selectedMembersPhones, removedMembersPhones, isFamilyBundleEdit: !!data.isFamilyBundleEdit};
  } catch (error) {
    return {
      error: true,
      errorCode: '99',
    };
  }
});
export const updatePackage = createAsyncThunk('cellcomAbroad/updatePackage', async (data, thunkAPI) => {
  try {
    if (!data?.noLoader) {
      thunkAPI.dispatch(showAppLoader());
    }
    // Store  before async calls
    var mobile = data.phoneNumber;
    var newDate = data.newDateToUpdate;
    var socName = data.soc;
    var oldDate = data.effDate;

    const result = await ProviderManager.getProviderData('abroadUpdateSoc', [
      mobile,
      socName,
      oldDate,
      data.expDate,
      newDate,
      data.blockId,
    ]);
    thunkAPI.dispatch(hideAppLoader());
    if (result.Body.isSuccess) {
      if (data.isBusinessIndividual) {
        const dataToSend = {
          phoneNumber: mobile,
          goldBusinessPackagesBlockId: data.goldBusinessPackagesBlockId ? data.goldBusinessPackagesBlockId : '',
          blockId: data.businessId,
          orgId: data.orgId,
        };
        thunkAPI.dispatch(getCustomerAbroadPackagesBusinessIndividual(dataToSend));
      } else {
        const dataToSend = {
          mobile: mobile,
          privateBlockId: data.privateId,
          businessBlockId: data.businessId,
          goldBusinessPackagesBlockId: data.goldBusinessPackagesBlockId ? data.goldBusinessPackagesBlockId : '',
          addonsFolderBlockId: data.addonsFolderBlockId,
          noLoader: data?.noLoader,
        };
        thunkAPI.dispatch(getCustomerAbroadPackages(dataToSend));
      }
    }
    return {...result, mobile, oldDate, socName, newDate};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
      reason: error,
    };
  }
});
export const GetAbroadAdditionalServices = createAsyncThunk('cellcomAbroad/GetAbroadAdditionalServices', async (data, thunkAPI) => {
  try {
    if (!data?.noLoader) {
      thunkAPI.dispatch(showAppLoader());
    }
    const mobile = data.mobile;
    const result = await ProviderManager.getProviderData('GetAbroadAdditionalServices', [mobile, data.addonsFolderBlockId]);
    if (!data?.noLoader) {
      thunkAPI.dispatch(hideAppLoader());
    }
    return {
      error: false,
      data: result,
      mobile: mobile,
    };
  } catch (error) {
    if (!data?.noLoader) {
      thunkAPI.dispatch(hideAppLoader());
    }
    return {
      data: {},
      error: true,
    };
  }
});
export const getCustomerAbroadPackages = createAsyncThunk('cellcomAbroad/getCustomerAbroadPackages', async (data, thunkAPI) => {
  try {
    let goldPackagesFolder = data.goldBusinessPackagesBlockId ? data.goldBusinessPackagesBlockId : '';
    let addonsFolderBlockId = data.addonsFolderBlockId ? data.addonsFolderBlockId : '';
    const mobile = data.mobile; // Store mobile number before async calls
    const result = await ProviderManager.getProviderData('getCustomerAbroadPackages', [
      mobile,
      data.privateBlockId,
      data.businessBlockId,
      addonsFolderBlockId,
      goldPackagesFolder,
    ]);
    thunkAPI.dispatch(GetAbroadAdditionalServices({...data, mobile})); // Pass stored mobile number

    return {result: result, validatedPhone: mobile};
  } catch (error) {
    return {
      error: true,
      reason: error,
      validatedPhone: mobile,
    };
  }
});
export const removePackage = createAsyncThunk('cellcomAbroad/removePackage', async (data, thunkAPI) => {
  try {
    if (!data?.noLoader) {
      thunkAPI.dispatch(showAppLoader());
    }
    // Store  before async calls
    var mobile = data.mobile;
    var socName = data.soc;
    var isAddon = data.isAddon;
    var startDate = data.startDate;

    const shouldRemoveSurfingBlockSoc = data.shouldRemoveSurfingBlockSoc;
    const result = await ProviderManager.getProviderData('removePackage', [
      data.soc,
      mobile,
      data.startDate,
      data.shouldRemoveSurfingBlockSoc,
      data.blockId,
      data.isAddon,
    ]);

    thunkAPI.dispatch(hideAppLoader());

    return {...result, mobile, socName, isAddon, startDate, shouldRemoveSurfingBlockSoc};
  } catch (error) {
    thunkAPI.dispatch(hideAppLoader());
    return {
      error: true,
      reason: error,
    };
  }
});

export const removeCapSoc = createAsyncThunk('cellcomAbroad/removeCapSoc', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('removeCapSoc', data);
    return {result};
  } catch (error) {
    return {
      error: true,
      reason: error,
    };
  }
});

export const getCustomerAbroadUsageDisplay = createAsyncThunk('cellcomAbroad/getCustomerAbroadUsageDisplay', async (data, thunkAPI) => {
  try {
    let result;
    const mobile = data.mobile;
    result = await ProviderManager.getProviderData('getCustomerAbroadUsageDisplay', [data.mobile]);
    return {...result, mobile};
  } catch (error) {
    return {
      error: true,
      reason: error,
    };
  }
});

export const getUsageData = createAsyncThunk('cellcomAbroad/getUsageData', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('retrieveCustomerAbroadUsageData', [data.subscriber, data.toReport]);
    return result;
  } catch (error) {
    return {
      error: true,
    };
  }
});

export const fetchPackagePopular = createAsyncThunk(
  'cellcomAbroad/fetchPackagePopular',
  async ({SocIdList, BlockId, ClientType}, thunkApi) => {
    let response;

    try {
      const thisStore = thunkApi.getState();

      response = await ProviderManager.getProviderData('getAbroadPackagePopular', [
        SocIdList,
        BlockId,
        ClientType,
        thisStore.cellcomAbroad.otpData?.validatedCostumerData?.isSeparatedSale ? true : false,
      ]);
      return {
        response: response.Body,
        error: false,
      };
    } catch (e) {
      return {
        response: null,
        error: true,
      };
    }
  },
);

export const fetchPackagePopularMarket = createAsyncThunk('cellcomAbroad/fetchPackagePopularMarket', async (data, thunkApi) => {
  let response;
  try {
    const mobile = data.subscriber;
    const isReducedSocList = data.IsReducedSocList||false;
    response = await ProviderManager.getProviderData('getAbroadPackagePopular', [data.SocIdList, data.BlockId, data.ClientType, false,isReducedSocList]);
    return {
      response: response.Body,
      error: false,
      id: data.Id,
      mobile: mobile,
    };
  } catch (e) {
    return {
      response: null,
      error: true,
    };
  }
});

export const addAddonToPackage = createAsyncThunk('cellcomAbroad/addAddonToPackage', async (data, thunkAPI) => {
  try {
    const result = await ProviderManager.getProviderData('addAddonToPackage', [
      data.subscriberNumber,
      data.soc,
      data.startDate,
      data.countries,
      data.accountType,
      data.addonType,
      data.parentSocCode,
      data.blockId,
    ]);
    const mobile = data.subscriberNumber;
    const soc = data.soc;
    return {...result, soc, mobile};
  } catch (error) {
    return {
      error: true,
      errorCode: '99',
    };
  }
});

export const FetchFamilyBundleUsages = createAsyncThunk('cellcomAbroad/FetchFamilyBundleUsages', async (data, thunkAPI) => {
  const productSubscriberNo = thunkAPI.getState().selfcarePage?.selectedSubscriber?.productSubscriberNo;
  const subsDataArr = thunkAPI.getState().selfcarePage?.subscribersByProduct?.Cellular || [];
  try {
    const result = await ProviderManager.getProviderData('FetchFamilyBundleUsages', [data.subscriber]);
    return {
      error: false,
      data: result,
      subscriber: productSubscriberNo,
      subsDataArr: subsDataArr,
    };
  } catch (error) {
    return {
      data: {},
      error: true,
      subscriber: productSubscriberNo,
    };
  }
});

export const getCustomerAbroadPackagesBusinessIndividual = createAsyncThunk(
  'cellcomAbroad/getCustomerAbroadPackagesBusinessIndividual',
  async (data, thunkAPI) => {
    let goldPackagesFolder = data.goldBusinessPackagesBlockId ? data.goldBusinessPackagesBlockId : '';
    try {
      const result = await ProviderManager.getProviderData('getCustomerAbroadPackagesBusinessIndividual', [
        data.phoneNumber,
        goldPackagesFolder,
        data.blockId,
        data.orgId,
      ]);
      return result;
    } catch (error) {
      return {
        error: true,
        reason: error,
      };
    }
  },
);

export const abroadRemoveAndAddSocFamily = createAsyncThunk(
  'cellcomAbroad/AddFamilyPackage',
  async (
    {
      SubscriberNoParent,
      soc,
      startDate,
      endDate,
      countries,
      blockId,
      shouldRemoveSurfingBlockage,
      type,
      OtpTicketChildren,
      SubscriberChildren,
      startDateParent,
      socCodePackageGiveFamilyBonus
    },
    thunkAPI,
  ) => {
    try {
      var mobile = SubscriberChildren;

      var state = thunkAPI.getState().cellcomAbroad;
      var selectedAbroadPackage = state.selectedAbroadPackage;
      var couponSerial = state.coupon?.code;
      var couponCode= state.coupon?.voucherCategory || '';

      var newPackage = {...selectedAbroadPackage, startDate: startDate};

      const result = await ProviderManager.getProviderData('AddFamilyPackage', [
        SubscriberNoParent,
        soc,
        startDate,
        endDate,
        countries,
        blockId,
        shouldRemoveSurfingBlockage,
        type,
        OtpTicketChildren,
        SubscriberChildren,
        startDateParent,
        socCodePackageGiveFamilyBonus,
        couponCode,
        couponSerial
      ]);
      return {...result, mobile, newPackage, SubscriberNoParent};
    } catch (error) {
      return {
        error: true,
        errorCode: '99',
      };
    }
  },
);
